module.exports = __webpack_public_path__ + "application/directives/svg-image/sync-svg/sync-svg.template.html";